const list = {
    or: 'ou',
    and: 'et',
    separator: ',',
};
export default Object.freeze(list);
